export const hoverUnderlineStyle = {
  position: "relative",
  width: "fit-content",
  cursor: "pointer",
  fontFamily: "NotoSansJP",
  "&::after": {
    content: '""',
    position: "absolute",
    left: 0,
    bottom: -5,
    width: "100%",
    height: "1px",
    backgroundColor: "#f84525",
    transformOrigin: "right",
    transform: "scaleX(1)",
    transition: "transform 0.3s ease",
  },
  "&:hover::after": {
    transform: "scaleX(0)",
  },
};

export const menuItemStyle = {
  position: "relative",
  width: "fit-content",
  whiteSpace: "nowrap",
  color: "#9c9c9c",
  cursor: "pointer",
  fontFamily: "NotoSansJP",
  m: "0 25px 20px 0px",
  "&::after": {
    content: '""',
    position: "absolute",
    left: 0,
    bottom: -5,
    width: "100%",
    height: "1px",
    backgroundColor: "#9c9c9c",
    transformOrigin: "left",
    transform: "scaleX(0)",
    transition: "transform 0.3s ease",
  },
  "&:hover::after": {
    transform: "scaleX(1)",
  },
};

export const menuTextStyle = {
  cursor: "pointer",
  position: "relative",
  lineHeight: 1.5,
  transition: "0.2s all linear",
};

export const burgerLineStyle = {
  width: "20px",
  height: "10px",
  position: "relative",
  "&::after": {
    content: '""',
    width: "20px",
    height: "2px",
    position: "absolute",
    top: "0",
    background: "#323e59",
  },
  "&::before": {
    content: '""',
    width: "10px",
    height: "2px",
    position: "absolute",
    top: "8px",
    background: "#323e59",
  },
};
